export const GCLID = 'gclid';
export const GCLID_LT = 'gclid_lt';
export const PAR = 'par';
export const PAR_LT = 'par_lt';
export const REFERRER_URL = 'referrer_url';
export const REFERRER_URL_LT = 'referrer_url_lt';
export const LANDING_PAGE_URL = 'landing_page_url';
export const LANDING_PAGE_URL_LT = 'landing_page_url_lt';

export const ATTRIBUTION_COOKIES: readonly string[] = [
  GCLID,
  GCLID_LT,
  PAR,
  PAR_LT,
  REFERRER_URL,
  REFERRER_URL_LT,
  LANDING_PAGE_URL,
  LANDING_PAGE_URL_LT,
];
